const isAdminAccess = account => account?.userType < 10;
const isSystem = userId => userId === 1;

export { isAdminAccess, isSystem };
